import React from "react";
import { useLang, useSettings, cldUrl } from "../lib/providers";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  const { lang } = useLang();
  const { settings } = useSettings();
  if (!settings.testimonials_enabled) return null;
  const items = settings.testimonials || [];
  if (items.length === 0) return null;
  const title = lang === "ar" ? settings.testimonials_title_ar : settings.testimonials_title_fr;

  return (
    <section className="py-20 sm:py-28 theme-section-alt relative" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-neon mb-3">★★★★★</p>
        <h2 className="font-heading font-black uppercase tracking-tighter text-4xl sm:text-5xl mb-12">{title}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it) => (
            <div key={it.id} className="themed-card p-5 relative" data-testid={`testimonial-${it.id}`}>
              <Quote className="w-8 h-8 text-neon/30 absolute top-3 end-3" />
              <div className="flex gap-1 mb-3">
                {Array.from({ length: it.rating || 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-neon fill-current" />
                ))}
              </div>
              {it.image_url && (
                <div className="mb-3 -mx-5 -mt-5 aspect-video bg-black/30 overflow-hidden">
                  <img src={cldUrl(it.image_url, { w: 200 })} alt="" className="w-full h-full object-cover" loading="lazy" decoding="async" />
                </div>
              )}
              <p className="text-sm text-white/85 leading-relaxed whitespace-pre-line">
                {(lang === "ar" ? it.text_ar : it.text_fr) || it.text_fr}
              </p>
              <div className="mt-4 pt-3 border-t border-white/10 flex items-center justify-between">
                <span className="font-heading font-bold text-sm uppercase">{it.name || "Client"}</span>
                {it.wilaya && <span className="text-[10px] tracking-widest uppercase text-white/50">{it.wilaya}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
